import auth from '@/middleware/auth';
import guest from '@/middleware/guest';

// Pages
import Login from '@/components/views/pages/Login.vue';
import Register from '@/components/views/pages/Register.vue';
import EmailVerification from '@/components/views/pages/EmailVerification.vue';
import ForgotPassword from '@/components/views/pages/ForgotPassword.vue';
import PasswordReset from '@/components/views/pages/PasswordReset.vue';
import ConfirmRegister from '@/components/views/pages/ConfirmRegister.vue';
import NotFound from '@/components/views/pages/NotFound.vue';
import CompanyPage from '@/components/views/pages/CompanyPage.vue';
import InvoicePage from '@/components/views/pages/InvoicePage.vue';
import Overview from '@/components/views/pages/dashboard/overview/Overview.vue';
import InvoiceForm from '@/components/views/pages/invoice/InvoiceForm.vue';
import InvoiceList from '@/components/views/pages/invoice/InvoiceList.vue';
import InvoiceFree from '@/components/views/pages/invoice/InvoiceAdd.vue';
import InvoiceOverview from '@/components/views/pages/invoice/InvoiceOverview.vue';
import Company from '@/components/views/pages/Company.vue';
import CompanyList from '@/components/views/pages/company/CompanyList.vue';
import TaxCalculator from '@/components/views/pages/tax/TaxCalculator.vue';
import UserProfile from '@/components/views/pages/user/Profile.vue';
import Faq from '@/components/views/pages/menu/Faq.vue';
import Help from '@/components/views/pages/menu/Help.vue';
import GoogleCallback from '@/components/views/pages/GoogleCallback.vue';
import ClientList from '@/components/views/pages/client/ClientList.vue';
import Client from '@/components/views/pages/client/Client.vue';
import VerifyEmailGate from '@/components/views/pages/VerifyEmailGate.vue'
import Plans from '@/components/views/pages/Plans.vue'

const routes = [
    {
        path: '/',
        redirect: '/dashboard/overview',
        name: 'dashboard'
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { layout: 'full', middleware: guest },
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: { layout: 'full', middleware: guest },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: { layout: 'full', middleware: guest },
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset,
        meta: { layout: 'full', middleware: guest },
    },
    {
        path: '/email/verify',
        name: 'verifyEmailGate',
        component: VerifyEmailGate,
        meta: { layout: 'full', middleware: guest },
    },
    {
        path: '/email/verify/error',
        name: 'verification',
        component: EmailVerification,
        meta: { layout: 'full', middleware: guest,},
        props: true, 
    },
    {
        path: '/invoice/free',
        name: 'invoice-free',
        component: InvoiceFree,
        meta: { layout: 'full' },
    },
    {
        path: '/invoice',
        component: InvoicePage,
        meta: { middleware: auth },
        children: [
            {
                path: 'create',
                name: 'add-invoice',
                component: InvoiceForm,
                meta: { middleware: auth },
            },
            {
                path: 'list',
                name: 'invoices',
                component: InvoiceList,
                meta: { middleware: auth },
            },
            {
                path: 'overview/:id',
                name: 'invoice',
                component: InvoiceOverview,
                meta: { middleware: auth },
            },
        ],
    },
    {
        path: '/company',
        component: CompanyPage,
        meta: { middleware: auth },
        children: [
            {
                path: 'add',
                name: 'addCompany',
                component: Company,
                meta: { middleware: auth },
            },
            {
                path: 'list',
                name: 'companies',
                component: CompanyList,
                meta: { middleware: auth },
            },
        ],
    },
    {
        path: '/profile',
        name: 'profile',
        component: UserProfile,
        meta: { middleware: auth },
    },
    {
        path: '/faq',
        name: 'faq',
        component: Faq,
        meta: { middleware: auth },
    },
    {
        path: '/help',
        name: 'help',
        component: Help,
        meta: { middleware: auth },
    },
    {
        path: '/confirm-registration',
        name: 'confirmRegister',
        component: ConfirmRegister,
        meta: { layout: 'full', middleware: guest,}
    },
    {
        path: '/dashboard/overview',
        name: 'dashboard-overview',
        component: Overview,
        meta: { middleware: auth},
    },
    {
        path: '/tax/calculator',
        name: 'tax-calculator',
        component: TaxCalculator,
        meta: { middleware: auth },
    },
    {
        path: '/auth/google/callback',
        name: 'GoogleCallback',
        component: GoogleCallback,
        meta: { middleware: guest, layout: 'full' },
    },
    {
        path: '/client/list',
        name: 'client-list',
        component: ClientList,
        meta: { middleware: auth },
    },
    {
        path: '/client/:id',
        name: 'client',
        component: Client,
        meta: { middleware: auth },
    },
    {
        path: '/plans',
        name: 'pricing',
        component: Plans,
        meta: { middleware: auth },
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound,
        meta: { layout: 'full' },
    },
];

export default routes;